import { FAKE_RUSSIA_REGION } from '../../constants/fakeRegions';
import { IFilters } from '../../types/filters';

export function getRegionID(filters: IFilters): number {
  return filters.location ?? FAKE_RUSSIA_REGION.id;
}
